import React from 'react';
import { isBugsnagEnabled, bugsnagClient } from 'common/bugsnagClient';

const DoNothing = ({ children }) => children;

export const BugsnagErrorBoundary = isBugsnagEnabled()
  ? bugsnagClient.getPlugin('react').createErrorBoundary(React)
  : DoNothing;
